import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { delayedRetryHttp } from '../../shared/delayedRetry';
import { UtilityService } from './utility.service';

@Injectable()
export class CurrencyConversionService {
    private baseUrl: string;
    private api: string = "api/CurrencyConvert";
    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }
    async getConversionrate(encryptedUser: string, currencyType: string):Promise<string | void> {
        const a = await this.httpClient
            .get<string>(`${this.baseUrl}/GetConversionRate/${currencyType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "currencyType - " + currencyType, encryptedUser, "CurrencyConversionService", "getConversionrate"); });

        return a;
       
    }
}
